module.exports = __webpack_public_path__ + "static/8-14f9dbf73ace415a5c6a168c1e9de566.jpg";